/* js/components/Switch.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	create_component,
	create_slot,
	destroy_component,
	detach,
	element,
	get_all_dirty_from_scope,
	get_slot_changes,
	init,
	insert,
	is_function,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	space,
	transition_in,
	transition_out,
	update_slot_base
} from "svelte/internal";

import { onMount, onDestroy, createEventDispatcher } from "svelte";
import defaultCheckedIcon from "./CheckedIcon.svelte";
import defaultUncheckedIcon from "./UncheckedIcon.svelte";
import getBackgroundColor from "../switch-utility";
const get_unCheckedIcon_slot_changes = dirty => ({});
const get_unCheckedIcon_slot_context = ctx => ({});
const get_checkedIcon_slot_changes = dirty => ({});
const get_checkedIcon_slot_context = ctx => ({});

// (313:31)           
function fallback_block_1(ctx) {
	let cicon;
	let current;
	cicon = new /*CIcon*/ ctx[18]({});

	return {
		c() {
			create_component(cicon.$$.fragment);
		},
		m(target, anchor) {
			mount_component(cicon, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(cicon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(cicon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(cicon, detaching);
		}
	};
}

// (318:33)           
function fallback_block(ctx) {
	let uicon;
	let current;
	uicon = new /*UIcon*/ ctx[19]({});

	return {
		c() {
			create_component(uicon.$$.fragment);
		},
		m(target, anchor) {
			mount_component(uicon, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(uicon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(uicon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(uicon, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div4;
	let div2;
	let div0;
	let t0;
	let div1;
	let div2_onmousedown_value;
	let t1;
	let div3;
	let t2;
	let input;
	let current;
	let mounted;
	let dispose;
	const checkedIcon_slot_template = /*#slots*/ ctx[35].checkedIcon;
	const checkedIcon_slot = create_slot(checkedIcon_slot_template, ctx, /*$$scope*/ ctx[34], get_checkedIcon_slot_context);
	const checkedIcon_slot_or_fallback = checkedIcon_slot || fallback_block_1(ctx);
	const unCheckedIcon_slot_template = /*#slots*/ ctx[35].unCheckedIcon;
	const unCheckedIcon_slot = create_slot(unCheckedIcon_slot_template, ctx, /*$$scope*/ ctx[34], get_unCheckedIcon_slot_context);
	const unCheckedIcon_slot_or_fallback = unCheckedIcon_slot || fallback_block(ctx);

	return {
		c() {
			div4 = element("div");
			div2 = element("div");
			div0 = element("div");
			if (checkedIcon_slot_or_fallback) checkedIcon_slot_or_fallback.c();
			t0 = space();
			div1 = element("div");
			if (unCheckedIcon_slot_or_fallback) unCheckedIcon_slot_or_fallback.c();
			t1 = space();
			div3 = element("div");
			t2 = space();
			input = element("input");
			attr(div0, "style", /*checkedIconStyle*/ ctx[5]);
			attr(div1, "style", /*uncheckedIconStyle*/ ctx[6]);
			attr(div2, "class", "react-switch-bg");
			attr(div2, "style", /*backgroundStyle*/ ctx[4]);
			attr(div2, "onmousedown", div2_onmousedown_value = func);
			attr(div3, "class", "react-switch-handle");
			attr(div3, "style", /*handleStyle*/ ctx[7]);
			attr(input, "type", "checkbox");
			attr(input, "role", "switch");
			input.disabled = /*disabled*/ ctx[0];
			attr(input, "style", /*inputStyle*/ ctx[8]);
			attr(div4, "class", /*containerClass*/ ctx[1]);
			attr(div4, "style", /*rootStyle*/ ctx[3]);
		},
		m(target, anchor) {
			insert(target, div4, anchor);
			append(div4, div2);
			append(div2, div0);

			if (checkedIcon_slot_or_fallback) {
				checkedIcon_slot_or_fallback.m(div0, null);
			}

			append(div2, t0);
			append(div2, div1);

			if (unCheckedIcon_slot_or_fallback) {
				unCheckedIcon_slot_or_fallback.m(div1, null);
			}

			append(div4, t1);
			append(div4, div3);
			append(div4, t2);
			append(div4, input);
			/*input_binding*/ ctx[36](input);
			current = true;

			if (!mounted) {
				dispose = [
					listen(div2, "click", function () {
						if (is_function(/*disabled*/ ctx[0] ? null : /*onClick*/ ctx[17])) (/*disabled*/ ctx[0] ? null : /*onClick*/ ctx[17]).apply(this, arguments);
					}),
					listen(div3, "click", click_handler),
					listen(div3, "mousedown", function () {
						if (is_function(/*disabled*/ ctx[0] ? null : /*onMouseDown*/ ctx[9])) (/*disabled*/ ctx[0] ? null : /*onMouseDown*/ ctx[9]).apply(this, arguments);
					}),
					listen(div3, "touchstart", function () {
						if (is_function(/*disabled*/ ctx[0] ? null : /*onTouchStart*/ ctx[10])) (/*disabled*/ ctx[0] ? null : /*onTouchStart*/ ctx[10]).apply(this, arguments);
					}),
					listen(div3, "touchmove", function () {
						if (is_function(/*disabled*/ ctx[0] ? null : /*onTouchMove*/ ctx[11])) (/*disabled*/ ctx[0] ? null : /*onTouchMove*/ ctx[11]).apply(this, arguments);
					}),
					listen(div3, "touchend", function () {
						if (is_function(/*disabled*/ ctx[0] ? null : /*onTouchEnd*/ ctx[12])) (/*disabled*/ ctx[0] ? null : /*onTouchEnd*/ ctx[12]).apply(this, arguments);
					}),
					listen(div3, "touchcancel", function () {
						if (is_function(/*disabled*/ ctx[0] ? null : /*unsetHasOutline*/ ctx[16])) (/*disabled*/ ctx[0] ? null : /*unsetHasOutline*/ ctx[16]).apply(this, arguments);
					}),
					listen(input, "focus", /*setHasOutline*/ ctx[15]),
					listen(input, "blur", /*unsetHasOutline*/ ctx[16]),
					listen(input, "keyup", /*onKeyUp*/ ctx[14]),
					listen(input, "change", /*onInputChange*/ ctx[13])
				];

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (checkedIcon_slot) {
				if (checkedIcon_slot.p && (!current || dirty[1] & /*$$scope*/ 8)) {
					update_slot_base(
						checkedIcon_slot,
						checkedIcon_slot_template,
						ctx,
						/*$$scope*/ ctx[34],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[34])
						: get_slot_changes(checkedIcon_slot_template, /*$$scope*/ ctx[34], dirty, get_checkedIcon_slot_changes),
						get_checkedIcon_slot_context
					);
				}
			}

			if (!current || dirty[0] & /*checkedIconStyle*/ 32) {
				attr(div0, "style", /*checkedIconStyle*/ ctx[5]);
			}

			if (unCheckedIcon_slot) {
				if (unCheckedIcon_slot.p && (!current || dirty[1] & /*$$scope*/ 8)) {
					update_slot_base(
						unCheckedIcon_slot,
						unCheckedIcon_slot_template,
						ctx,
						/*$$scope*/ ctx[34],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[34])
						: get_slot_changes(unCheckedIcon_slot_template, /*$$scope*/ ctx[34], dirty, get_unCheckedIcon_slot_changes),
						get_unCheckedIcon_slot_context
					);
				}
			}

			if (!current || dirty[0] & /*uncheckedIconStyle*/ 64) {
				attr(div1, "style", /*uncheckedIconStyle*/ ctx[6]);
			}

			if (!current || dirty[0] & /*backgroundStyle*/ 16) {
				attr(div2, "style", /*backgroundStyle*/ ctx[4]);
			}

			if (!current || dirty[0] & /*handleStyle*/ 128) {
				attr(div3, "style", /*handleStyle*/ ctx[7]);
			}

			if (!current || dirty[0] & /*disabled*/ 1) {
				input.disabled = /*disabled*/ ctx[0];
			}

			if (!current || dirty[0] & /*inputStyle*/ 256) {
				attr(input, "style", /*inputStyle*/ ctx[8]);
			}

			if (!current || dirty[0] & /*containerClass*/ 2) {
				attr(div4, "class", /*containerClass*/ ctx[1]);
			}

			if (!current || dirty[0] & /*rootStyle*/ 8) {
				attr(div4, "style", /*rootStyle*/ ctx[3]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(checkedIcon_slot_or_fallback, local);
			transition_in(unCheckedIcon_slot_or_fallback, local);
			current = true;
		},
		o(local) {
			transition_out(checkedIcon_slot_or_fallback, local);
			transition_out(unCheckedIcon_slot_or_fallback, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div4);
			if (checkedIcon_slot_or_fallback) checkedIcon_slot_or_fallback.d(detaching);
			if (unCheckedIcon_slot_or_fallback) unCheckedIcon_slot_or_fallback.d(detaching);
			/*input_binding*/ ctx[36](null);
			mounted = false;
			run_all(dispose);
		}
	};
}

const func = e => e.preventDefault();
const click_handler = e => e.preventDefault();

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let { checked } = $$props;
	let { disabled = false } = $$props;
	let { offColor = "#666666" } = $$props;
	let { onColor = "#6788f4" } = $$props;
	let { offHandleColor = "#fff" } = $$props;
	let { onHandleColor = "#fff" } = $$props;
	let { handleDiameter } = $$props;
	let { unCheckedIcon = defaultUncheckedIcon } = $$props;
	let { checkedIcon = defaultCheckedIcon } = $$props;
	let { boxShadow = null } = $$props;
	let { activeBoxShadow = "0 0 2px 3px #3bf" } = $$props;
	let { height = 28 } = $$props;
	let { width = 56 } = $$props;
	let { id = "" } = $$props;
	let { containerClass = "" } = $$props;
	const dispatch = createEventDispatcher();

	//state
	let state = {
		handleDiameter: 0,
		checkedPos: 0,
		uncheckedPos: 0,
		pos: 0,
		lastDragAt: 0,
		lastKeyUpAt: 0,
		startX: null,
		hasOutline: null,
		dragStartingTime: null,
		checkedStateFromDragging: false
	};

	let inputRef = null;
	state.handleDiameter = handleDiameter || height - 2;
	state.checkedPos = Math.max(width - height, width - (height + state.handleDiameter) / 2);
	state.uncheckedPos = Math.max(0, (height - state.handleDiameter) / 2);
	state.pos = checked ? state.checkedPos : state.uncheckedPos;
	state.lastDragAt = 0;
	state.lastKeyUpAt = 0;

	//event handlers
	function onDragStart(clientX) {
		inputRef && inputRef.focus && inputRef.focus();
		$$invalidate(33, state.startX = clientX, state);
		$$invalidate(33, state.hasOutline = true, state);
		$$invalidate(33, state.dragStartingTime = Date.now(), state);
	}

	function onDrag(clientX) {
		let { startX, isDragging, pos } = state;
		const startPos = checked ? state.checkedPos : state.uncheckedPos;
		const mousePos = startPos + clientX - startX;

		// We need this check to fix a windows glitch where onDrag is triggered onMouseDown in some cases
		if (!isDragging && clientX !== startX) {
			$$invalidate(33, state.isDragging = true, state);
		}

		const newPos = Math.min(state.checkedPos, Math.max(state.uncheckedPos, mousePos));

		// Prevent unnecessary rerenders
		if (newPos !== pos) {
			$$invalidate(33, state.pos = newPos, state);
		}
	}

	function onDragStop(event) {
		let { pos, isDragging, dragStartingTime } = state;
		const halfwayCheckpoint = (state.checkedPos + state.uncheckedPos) / 2;

		// Simulate clicking the handle
		const timeSinceStart = Date.now() - dragStartingTime;

		if (!isDragging || timeSinceStart < 250) {
			onChangeTrigger(event);
		} else if (checked) {
			if (pos > halfwayCheckpoint) {
				$$invalidate(33, state.pos = state.checkedPos, state); // Handle dragging from checked position
			} else {
				onChangeTrigger(event);
			}
		} else if (pos < halfwayCheckpoint) {
			$$invalidate(33, state.pos = state.uncheckedPos, state); // Handle dragging from unchecked position
		} else {
			onChangeTrigger(event);
		}

		$$invalidate(33, state.isDragging = false, state);
		$$invalidate(33, state.hasOutline = false, state);
		$$invalidate(33, state.lastDragAt = Date.now(), state);
	}

	function onMouseDown(event) {
		event.preventDefault();

		// Ignore right click and scroll
		if (typeof event.button === "number" && event.button !== 0) {
			return;
		}

		onDragStart(event.clientX);
		window.addEventListener("mousemove", onMouseMove);
		window.addEventListener("mouseup", onMouseUp);
	}

	function onMouseMove(event) {
		event.preventDefault();
		onDrag(event.clientX);
	}

	function onMouseUp(event) {
		onDragStop(event);
		window.removeEventListener("mousemove", onMouseMove);
		window.removeEventListener("mouseup", onMouseUp);
	}

	function onTouchStart(event) {
		$$invalidate(33, state.checkedStateFromDragging = null, state);
		onDragStart(event.touches[0].clientX);
	}

	function onTouchMove(event) {
		onDrag(event.touches[0].clientX);
	}

	function onTouchEnd(event) {
		event.preventDefault();
		onDragStop(event);
	}

	function onInputChange(event) {
		// This condition is unfortunately needed in some browsers where the input's change event might get triggered
		// right after the dragstop event is triggered (occurs when dropping over a label element)
		if (Date.now() - state.lastDragAt > 50) {
			onChangeTrigger(event);

			// Prevent clicking label, but not key activation from setting outline to true - yes, this is absurd
			if (Date.now() - state.lastKeyUpAt > 50) {
				$$invalidate(33, state.hasOutline = false, state);
			}
		}
	}

	function onKeyUp() {
		$$invalidate(33, state.lastKeyUpAt = Date.now(), state);
	}

	function setHasOutline() {
		$$invalidate(33, state.hasOutline = true, state);
	}

	function unsetHasOutline() {
		$$invalidate(33, state.hasOutline = false, state);
	}

	function onClick(event) {
		event.preventDefault();
		inputRef.focus();
		onChangeTrigger(event);
		$$invalidate(33, state.hasOutline = false, state);
	}

	function onChangeTrigger(event) {
		$$invalidate(20, checked = !checked);
		dispatch("change", { checked, event, id });
	}

	//Hack since components should always to starting with Capital letter and props are camelCasing
	let CIcon = checkedIcon;

	let UIcon = unCheckedIcon;

	//styles
	let rootStyle = "";

	let backgroundStyle = "";
	let checkedIconStyle = "";
	let uncheckedIconStyle = "";
	let handleStyle = "";
	let inputStyle = "";

	function input_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			inputRef = $$value;
			$$invalidate(2, inputRef);
		});
	}

	$$self.$$set = $$props => {
		if ('checked' in $$props) $$invalidate(20, checked = $$props.checked);
		if ('disabled' in $$props) $$invalidate(0, disabled = $$props.disabled);
		if ('offColor' in $$props) $$invalidate(21, offColor = $$props.offColor);
		if ('onColor' in $$props) $$invalidate(22, onColor = $$props.onColor);
		if ('offHandleColor' in $$props) $$invalidate(23, offHandleColor = $$props.offHandleColor);
		if ('onHandleColor' in $$props) $$invalidate(24, onHandleColor = $$props.onHandleColor);
		if ('handleDiameter' in $$props) $$invalidate(25, handleDiameter = $$props.handleDiameter);
		if ('unCheckedIcon' in $$props) $$invalidate(26, unCheckedIcon = $$props.unCheckedIcon);
		if ('checkedIcon' in $$props) $$invalidate(27, checkedIcon = $$props.checkedIcon);
		if ('boxShadow' in $$props) $$invalidate(28, boxShadow = $$props.boxShadow);
		if ('activeBoxShadow' in $$props) $$invalidate(29, activeBoxShadow = $$props.activeBoxShadow);
		if ('height' in $$props) $$invalidate(30, height = $$props.height);
		if ('width' in $$props) $$invalidate(31, width = $$props.width);
		if ('id' in $$props) $$invalidate(32, id = $$props.id);
		if ('containerClass' in $$props) $$invalidate(1, containerClass = $$props.containerClass);
		if ('$$scope' in $$props) $$invalidate(34, $$scope = $$props.$$scope);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty[0] & /*checked*/ 1048576 | $$self.$$.dirty[1] & /*state*/ 4) {
			$: if (!state.isDragging) {
				$$invalidate(33, state.pos = checked ? state.checkedPos : state.uncheckedPos, state);
			}
		}

		if ($$self.$$.dirty[0] & /*disabled, height*/ 1073741825) {
			$: $$invalidate(3, rootStyle = `
    position: relative;
    display: inline-block;
    text-align: left;
    opacity: ${disabled ? 0.5 : 1};
    direction: ltr;
    border-radius: ${height / 2}px;
    transition: opacity 0.25s;
    touch-action: none;
    webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    user-select: none;
  `);
		}

		if ($$self.$$.dirty[0] & /*height, offColor, onColor, disabled*/ 1080033281 | $$self.$$.dirty[1] & /*width, state*/ 5) {
			$: $$invalidate(4, backgroundStyle = `
    height: ${height}px;
    width: ${width}px;
    margin: ${Math.max(0, (state.handleDiameter - height) / 2)}px;
    position: relative;
    background: ${getBackgroundColor(state.pos, state.checkedPos, state.uncheckedPos, offColor, onColor)};
    border-radius: ${height / 2}px;
    cursor: ${disabled ? "default" : "pointer"};
    transition: ${state.isDragging ? null : "background 0.25s"};
  `);
		}

		if ($$self.$$.dirty[0] & /*height*/ 1073741824 | $$self.$$.dirty[1] & /*width, state*/ 5) {
			$: $$invalidate(5, checkedIconStyle = `
    height: ${height}px;
    width: ${Math.min(height * 1.5, width - (state.handleDiameter + height) / 2 + 1)}px;
    position: relative;
    opacity:
      ${(state.pos - state.uncheckedPos) / (state.checkedPos - state.uncheckedPos)};
    pointer-events: none;
    transition: ${state.isDragging ? null : "opacity 0.25s"};
  `);
		}

		if ($$self.$$.dirty[0] & /*height*/ 1073741824 | $$self.$$.dirty[1] & /*width, state*/ 5) {
			$: $$invalidate(6, uncheckedIconStyle = `
    height: ${height}px;
    width: ${Math.min(height * 1.5, width - (state.handleDiameter + height) / 2 + 1)}px;
    position: absolute;
    opacity:
      ${1 - (state.pos - state.uncheckedPos) / (state.checkedPos - state.uncheckedPos)};
    right: 0px;
    top: 0px;
    pointer-events: none;
    transition: ${state.isDragging ? null : "opacity 0.25s"};
  `);
		}

		if ($$self.$$.dirty[0] & /*offHandleColor, onHandleColor, disabled, height, activeBoxShadow, boxShadow*/ 1904214017 | $$self.$$.dirty[1] & /*state*/ 4) {
			$: $$invalidate(7, handleStyle = `
    height: ${state.handleDiameter}px;
    width: ${state.handleDiameter}px;
    background: ${getBackgroundColor(state.pos, state.checkedPos, state.uncheckedPos, offHandleColor, onHandleColor)};
    display: inline-block;
    cursor: ${disabled ? "default" : "pointer"};
    border-radius: 50%;
    position: absolute;
    transform: translateX(${state.pos}px);
    top: ${Math.max(0, (height - state.handleDiameter) / 2)}px;
    outline: 0;
    box-shadow: ${state.hasOutline ? activeBoxShadow : boxShadow};
    border: 0;
    transition: ${state.isDragging
			? null
			: "background-color 0.25s, transform 0.25s, box-shadow 0.15s"};
  `);
		}
	};

	$: $$invalidate(8, inputStyle = `
    border: 0px;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0px;
    position: absolute;
    width: 1px;
  `);

	return [
		disabled,
		containerClass,
		inputRef,
		rootStyle,
		backgroundStyle,
		checkedIconStyle,
		uncheckedIconStyle,
		handleStyle,
		inputStyle,
		onMouseDown,
		onTouchStart,
		onTouchMove,
		onTouchEnd,
		onInputChange,
		onKeyUp,
		setHasOutline,
		unsetHasOutline,
		onClick,
		CIcon,
		UIcon,
		checked,
		offColor,
		onColor,
		offHandleColor,
		onHandleColor,
		handleDiameter,
		unCheckedIcon,
		checkedIcon,
		boxShadow,
		activeBoxShadow,
		height,
		width,
		id,
		state,
		$$scope,
		slots,
		input_binding
	];
}

class Switch extends SvelteComponent {
	constructor(options) {
		super();

		init(
			this,
			options,
			instance,
			create_fragment,
			safe_not_equal,
			{
				checked: 20,
				disabled: 0,
				offColor: 21,
				onColor: 22,
				offHandleColor: 23,
				onHandleColor: 24,
				handleDiameter: 25,
				unCheckedIcon: 26,
				checkedIcon: 27,
				boxShadow: 28,
				activeBoxShadow: 29,
				height: 30,
				width: 31,
				id: 32,
				containerClass: 1
			},
			null,
			[-1, -1]
		);
	}
}

export default Switch;